export class AccountModel {

  id = 0;
  name = '';
  color = '';
  logo = '';
  ssoEnabled = false;
  email2faEnabled = false;
  provider: string | null = null;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
